import { render, staticRenderFns } from "./CorporateTopDeals.vue?vue&type=template&id=807655e0&scoped=true&"
import script from "./CorporateTopDeals.vue?vue&type=script&lang=ts&"
export * from "./CorporateTopDeals.vue?vue&type=script&lang=ts&"
import style0 from "./CorporateTopDeals.vue?vue&type=style&index=0&id=807655e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807655e0",
  null
  
)

export default component.exports